// Copies of the .glb files eufy serves on its own product pages, checked
// 2026-09-25. Loaded from public/product-models so the report does not depend
// on Shopify at view time. Products absent from this map keep the photo zoom.
//
// Solar S340 Camera — https://www.eufy.com/products/t81701w1 — T8170_yh.glb
// HomeBase 3        — https://www.eufy.com/products/t80301d1 — T8030.glb
// FamiLock          — https://www.eufy.com/products/e85v0jy1 — E85V0.glb

const publicUrl = process.env.PUBLIC_URL || ''

export const PRODUCT_MODEL_FILES: Readonly<Record<string, string>> = {
  'FamiLock Doorbell + Lock': 'E85V0.glb',
  'HomeBase 3': 'T8030.glb',
  'Solar S340 Camera': 'T8170_yh.glb',
}

export const productModelUrl = (type: string): string | undefined => {
  const file = PRODUCT_MODEL_FILES[type]
  if (!file) return undefined
  return `${publicUrl}/product-models/${file}`
}
